"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var YouParticipate_1 = __importDefault(require("../YouParticipate"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var CurrentTournamentsButtonTimer = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var _j = (0, swr_hooks_1.useActiveTournaments)(), data = _j.data, isLoading = _j.isLoading;
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var bannerConfig = (0, swr_hooks_1.usePromoBannerConfig)(swr_hooks_1.TEXT_KEYS.TOURNAMENTS);
    var t = (0, next_intl_1.useTranslations)('translation');
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var _k = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _k.joinTournament, isSubmitting = _k.isSubmitting;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var currentTournament = (0, react_1.useMemo)(function () { return data === null || data === void 0 ? void 0 : data[0]; }, [data]);
    var time = (0, common_hooks_1.useTimer)({ endDate: currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.endDate }).time;
    var isMobile = Object.keys(breakpoints).length === 0 || Boolean(breakpoints.mobile);
    var containerStyle = (_b = (0, swr_hooks_1.getPromoBannerBackgroundStyle)(bannerConfig, isMobile)) !== null && _b !== void 0 ? _b : {
        backgroundImage: isMobile
            ? "url(".concat(((_d = (_c = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.baseTournament) === null || _c === void 0 ? void 0 : _c.images) === null || _d === void 0 ? void 0 : _d.mobileBanner) ||
                '/img/tournament_placeholder_mobile.jpg', " )")
            : "url(".concat(((_f = (_e = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.baseTournament) === null || _e === void 0 ? void 0 : _e.images) === null || _f === void 0 ? void 0 : _f.banner) ||
                '/img/tournament_placeholder.jpg', ")"),
    };
    var participate = (0, react_1.useCallback)(function (id) {
        if (!isAuth)
            return signUpNavigate();
        if (id)
            joinTournament({ id: id });
    }, [joinTournament, signUpNavigate, isAuth]);
    var onClickHandler = (0, react_1.useCallback)(function (e) {
        var _a;
        if (!e.target.closest('.participate')) {
            if (currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.id)
                router.push(generateUrlWithLang("/tournaments/".concat((_a = currentTournament.baseTournament) === null || _a === void 0 ? void 0 : _a.slug)));
        }
    }, [currentTournament, generateUrlWithLang, router]);
    var isFinished = (currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.endDate)
        ? new Date(currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.endDate) < new Date()
        : false;
    var isUserParticipate = (0, react_1.useMemo)(function () {
        return !!(currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.me);
    }, [currentTournament]);
    if (isLoading)
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    if (!currentTournament)
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.empty }, t('notAvailableTournamentsText')));
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("h2", { className: styles_module_scss_1.default.blockTitle }, t('currentTournaments')),
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isUserParticipate ? styles_module_scss_1.default.participate : ''), onClick: onClickHandler, style: containerStyle },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                        react_1.default.createElement("h3", null, translateLocale((_g = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.baseTournament) === null || _g === void 0 ? void 0 : _g.name))),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, translateLocale(((_h = currentTournament === null || currentTournament === void 0 ? void 0 : currentTournament.baseTournament) === null || _h === void 0 ? void 0 : _h.descriptions.short) || '')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.timerAndButton },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.participateContainer }, !isUserParticipate ? (!isFinished ? (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "300px", maxWidth: "100%", className: "participate", height: breakpoints.mobile ? '32px' : '48px', onClick: function () {
                                participate(currentTournament.id);
                            }, loading: isSubmitting },
                            t('joinNow'),
                            react_1.default.createElement("section", null,
                                react_1.default.createElement("span", null, t('timeLeft')),
                                " ",
                                time.days,
                                ":",
                                time.hours,
                                ":",
                                time.minutes,
                                ":",
                                time.seconds))) : null) : (react_1.default.createElement(YouParticipate_1.default, null)))))))));
};
exports.default = CurrentTournamentsButtonTimer;
